export default __webpack_public_path__ + "static/media/CV_EN.f29f0d77.pdf";